
const histories_name = 'histories'

const state = {
  histories: [],
  limit: 10
}

const mutations = {
  GET_HISTORY(state) {
    const histories = JSON.parse(
      localStorage.getItem(histories_name)
    )
    if(histories) {
      state.histories = histories 
    }
    // state.histories = histories
  },
  ADD_HISTORY (state, query) {
    this.commit('search/GET_HISTORY')
    const histories = state.histories
    const index = histories.indexOf(query)

    if (index > -1) {
      histories.splice(index, 1)
    }

    histories.unshift(query)

    if (histories.length > state.limit) {
      state.histories = histories.slice(0, 10)
    }

    this.commit('search/SAVE_HISTORIES')
  },
  SAVE_HISTORIES (state) {
    localStorage.setItem(
      histories_name,
      JSON.stringify(state.histories)
    )
  },
  CLEAR_HISTORIES(state) {
    localStorage.removeItem(histories_name)
    state.histories = []
  }
}

export default {
  state,
  mutations,
  namespaced: true
}